/**
 * Nhóm cán bộ
 */
 export default {
    PublicServants: 1,//Công chức
    Functionary : 2,//viên chức
    ContractLabor : 3, // Lao động hợp đồng
  };